import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <section>
      <footer>
        <Container fluid>
          <Row>
            <Col md={12}>
              <Container>
                <Row>
                  <Col md={6}>
                    <h2>Quick Links</h2>
                    <ul>
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/">Privacy Policy</Link>
                      </li>
                      <li>
                        <Link to="/">Shipping Policy</Link>
                      </li>
                      <li>
                        <Link to="/">Terms of Service</Link>
                      </li>
                      <li>
                        <Link to="/">Return and refund policy</Link>
                      </li>
                    </ul>
                  </Col>
                  <Col md={6}>
                    <h2>About Us</h2>
                    <p>Avdhesh in a new age company. Our mission is to expand our culture all over the world. You can join us also</p>
                    <p><strong>Whatsapp No:</strong> +91 9876543210 (No Calls)</p>
                    <p><strong>Email:</strong> <Link to="mailto:support@avdhesh.com">support@avdhesh.com</Link></p>
                  </Col>
                  <Col md={12}>
                    <ul className="social-links">
                      <li>
                        <Link to="/">Facebook</Link>
                      </li>
                      <li>

                        <Link to="/">Instagram</Link>
                      </li>
                      <li>
                        <Link to="/">Twitter</Link>
                      </li>
                      <li>
                        <Link to="/">Linkedin</Link>
                      </li>
                      <li>
                        <Link to="/">Youtube</Link>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </Container >
      </footer >
    </section >
  )
}
export default Footer;